import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router";
import App from './App';

import { DBDataProvider } from './contexts/DBDataSync';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <DBDataProvider>
      <App />
    </DBDataProvider>
  </BrowserRouter>
)